import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const certifikatPredelavaService = {
    load,loadAll,loadLastYear,save,remove,vrniPoId
    
};

function load(sezona,predelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/certifikat/?sezona=${sezona}&predelovalecid=${predelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}


function save(certifikat) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(certifikat)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/certifikat`, requestOptions).then(handleResponse);
}

function vrniPoId(id) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
    
    };
return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/certifikat/id/?id=${id}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {

            
            return certifikat;
        });
}

function remove(certifikat) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(certifikat)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/certifikat`, requestOptions).then(handleResponse);
}

function loadAll(sezona){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/predelava/certifikati/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });
}

function loadLastYear(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/predelava/predelovalec/certifikat/?sezona=${sezona}&predelovalecid=${predelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(certifikat => {
            // login successful if there's a jwt token in the response
            
            return certifikat;
        });

}
